// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root___Vkz7","title":"Header_title__2xHyt","side":"Header_side__3rAKq"};